import { matchesSubscriptionFilter } from "./myCompaniesFilterUtils";

/** @typedef {'all' | 'yes' | 'no' | 'expiring15'} CompanyListSubscriptionFilter */

/** @param {'clients' | 'partners'} partnerFilter */
export function filterCompaniesByPartner(companys, partnerFilter) {
  if (!Array.isArray(companys)) {
    return [];
  }
  if (partnerFilter === "partners") {
    return companys.filter((c) => c.is_partner === true);
  }
  return companys.filter((c) => !c.is_partner);
}

export function isCompanyArchived(company) {
  return company?.is_active === false;
}

/**
 * Активные в порядке API, затем архивные (если showArchive).
 */
export function partitionActiveAndArchive(companys, showArchive) {
  const active = [];
  const archived = [];
  companys.forEach((c) => {
    if (isCompanyArchived(c)) {
      archived.push(c);
    } else {
      active.push(c);
    }
  });
  if (!showArchive) {
    return active;
  }
  return [...active, ...archived];
}

export const COMPANY_LIST_SHOW_MINE_ONLY_KEY = "company_list_show_mine_only";

/**
 * @param {object} company
 * @param {string[]} visibleRegion — активные коды стран (FilterRegion)
 */
export function companyMatchesVisibleRegion(company, visibleRegion) {
  if (!Array.isArray(visibleRegion)) {
    return false;
  }
  const tag = company?.country_id_rel?.tag_country;
  if (tag != null && String(tag).trim() !== "") {
    return visibleRegion.includes(tag);
  }
  return visibleRegion.includes("RU");
}

/** @param {object} company @param {string|number|null|undefined} userId */
export function isCompanyAssignedToUser(company, userId) {
  if (userId == null || userId === "") return false;
  const uid = String(userId);
  const respId = company?.manager?.id;
  const supportId = company?.support_manager?.id;
  return (
    (respId != null && String(respId) === uid) ||
    (supportId != null && String(supportId) === uid)
  );
}

export function prepareCompanyList(
  companys,
  {
    partnerFilter,
    showArchive,
    showMineOnly,
    currentUserId,
    subscriptionFilter = "all",
  },
) {
  const byPartner = filterCompaniesByPartner(companys, partnerFilter);
  const byArchive = partitionActiveAndArchive(byPartner, showArchive);
  const byMine = showMineOnly
    ? byArchive.filter((c) => isCompanyAssignedToUser(c, currentUserId))
    : byArchive;
  if (subscriptionFilter === "all") {
    return byMine;
  }
  return byMine.filter((c) =>
    matchesSubscriptionFilter(c, subscriptionFilter),
  );
}

export const COMPANY_LIST_SHOW_ARCHIVE_KEY = "company_list_show_archive";
export const COMPANY_LIST_SUBSCRIPTION_FILTER_KEY =
  "company_list_subscription_filter";

const VALID_SUBSCRIPTION_FILTERS = new Set([
  "all",
  "yes",
  "no",
  "expiring15",
]);

/** @returns {CompanyListSubscriptionFilter} */
export function readCompanyListSubscriptionFilter() {
  const raw = localStorage.getItem(COMPANY_LIST_SUBSCRIPTION_FILTER_KEY);
  return VALID_SUBSCRIPTION_FILTERS.has(raw) ? raw : "all";
}
